// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OxTqNFdiWKiOOBKsfOj_ {
  position: relative;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz {
  display: flex;
  flex-direction: column;
  row-gap: 18px;
  width: 650px;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .E9YcAkI1PQTt0FLG8Vma {
  position: absolute;
  top: 16px;
  left: 32px;
  display: flex;
  align-items: center;
  column-gap: 8px;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .E9YcAkI1PQTt0FLG8Vma .KvbT0f8Vrs2trRGTIjUu {
  background-color: #774dee;
  padding: 6px 12px;
  border-radius: 8px;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .E9YcAkI1PQTt0FLG8Vma > img {
  width: 32px;
  height: 32px;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .VuFQSkoP7oHJiczQI5Fr {
  background: conic-gradient(from 0deg, #ff00cc, #ff00cc, #ff9900, #ff9900, #9900ff, #ff00cc);
  color: white;
  font-weight: bold;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  margin-left: 8px;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .v2szRqRRGOhMOj5fUpXW {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .v2szRqRRGOhMOj5fUpXW .fayNrshveISvCKPhBScN {
  font-size: 8px !important;
  color: #b6b6b6;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .v2szRqRRGOhMOj5fUpXW .fRxC68rOPaoSh0rMSLD3 {
  width: 20px !important;
  height: 20px !important;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .v2szRqRRGOhMOj5fUpXW .fRxC68rOPaoSh0rMSLD3 * {
  fill: #fff !important;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .v2szRqRRGOhMOj5fUpXW > div {
  display: flex;
  align-items: center;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .v2szRqRRGOhMOj5fUpXW > div > p {
  width: 250px;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .E1R0l93Ex93Ixu45CwSw {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .jc9XwDbH1EOE2R0T5qbV {
  display: flex;
  justify-content: space-between;
}
.OxTqNFdiWKiOOBKsfOj_ .vg9_rMNJWyDMfDESuvVz .jc9XwDbH1EOE2R0T5qbV .wUHtdZpsETwDxMyGxJ0_ {
  font-size: 28px;
}

.TG3g_gaT6VH9HsadvB2I {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10002;
  pointer-events: all;
  animation: RIOCHFM5Xoiyq5qWh1Rz 0.3s ease-out;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI {
  background: #444;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 32px;
  max-width: 500px;
  width: 90%;
  animation: LEIWuXIGzhXK9gx2Kyqt 0.4s ease-out;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .FwCCXSEjPtRwVpxlXbvv {
  display: flex;
  align-items: center;
  column-gap: 12px;
  margin-bottom: 24px;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .FwCCXSEjPtRwVpxlXbvv .F_BdnAH_x9jkPPUtUdap {
  font-size: 32px;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .FwCCXSEjPtRwVpxlXbvv h3 {
  color: #c3c3c3;
  font-size: 24px;
  margin: 0;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .ERTbxHPoSDzeHTz0KZqw {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-bottom: 24px;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .ERTbxHPoSDzeHTz0KZqw .bgWZfJMplWSzZapnDRIa {
  display: flex;
  align-items: flex-start;
  column-gap: 12px;
  padding: 16px;
  background: #393939;
  border-radius: 8px;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .ERTbxHPoSDzeHTz0KZqw .bgWZfJMplWSzZapnDRIa .EiSdHb4gDYS7uUp3Y6_j {
  font-size: 20px;
  line-height: 1;
  flex-shrink: 0;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .ERTbxHPoSDzeHTz0KZqw .bgWZfJMplWSzZapnDRIa .bCmATtxDaNHH8dOW0Fni {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  flex: 1;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .ERTbxHPoSDzeHTz0KZqw .bgWZfJMplWSzZapnDRIa .bCmATtxDaNHH8dOW0Fni .spRrEeN0zQ2RAJNQHaqb {
  font-size: 14px;
  color: #bbb;
  font-weight: 500;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .ERTbxHPoSDzeHTz0KZqw .bgWZfJMplWSzZapnDRIa .bCmATtxDaNHH8dOW0Fni .T4zlx9kFXOFUUulLj6OU {
  font-size: 16px;
  color: #c3c3c3;
  line-height: 1.4;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .B4_LY01cIqV9iOFR3DAg {
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 16px;
  background: #393939;
  border-radius: 8px;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .B4_LY01cIqV9iOFR3DAg .Hf6i_geka9ls_cbXLlkO {
  font-size: 18px;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .B4_LY01cIqV9iOFR3DAg .h2g2tBzF3ZJsFIGIJ7jN {
  color: #b6b6b6;
  font-size: 14px;
  font-weight: 500;
}
.TG3g_gaT6VH9HsadvB2I .zU3TDWGTVnkRO6CrFyfI .B4_LY01cIqV9iOFR3DAg .OcaLS9vZT5JJgg773DkQ {
  color: #8965ef;
  font-size: 14px;
  margin-left: 4px;
}

@keyframes RIOCHFM5Xoiyq5qWh1Rz {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes LEIWuXIGzhXK9gx2Kyqt {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/editor/components/modals/GeoModal/GeoModal.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AAAF;AAEE;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AAAJ;AAEI;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAAN;AAEM;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;AAAR;AAGM;EACE,WAAA;EACA,YAAA;AADR;AAKI;EACE,2FAAA;EASA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;EACA,yCAAA;EACA,mBAAA;EACA,gBAAA;AAXN;AAcI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAZN;AAcM;EACE,yBAAA;EACA,cAAA;AAZR;AAeM;EACE,sBAAA;EACA,uBAAA;AAbR;AAcQ;EACE,qBAAA;AAZV;AAgBM;EACE,aAAA;EACA,mBAAA;AAdR;AAgBQ;EACE,YAAA;AAdV;AAmBI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAjBN;AAoBI;EACE,aAAA;EACA,8BAAA;AAlBN;AAoBM;EACE,eAAA;AAlBR;;AAwBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,6CAAA;AArBF;AAuBE;EACE,gBCzDW;ED0DX,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,6CAAA;AArBJ;AAuBI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AArBN;AAuBM;EACE,eAAA;AArBR;AAwBM;EACE,cC9GQ;ED+GR,eAAA;EACA,SAAA;AAtBR;AA0BI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AAxBN;AA0BM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBC9FO;ED+FP,kBAAA;AAxBR;AA0BQ;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAxBV;AA2BQ;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;AAzBV;AA2BU;EACE,eAAA;EACA,WC9II;ED+IJ,gBAAA;AAzBZ;AA4BU;EACE,eAAA;EACA,cCtJI;EDuJJ,gBAAA;AA1BZ;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBCjIS;EDkIT,kBAAA;AA9BN;AAgCM;EACE,eAAA;AA9BR;AAiCM;EACE,cCzKQ;ED0KR,eAAA;EACA,gBAAA;AA/BR;AAkCM;EACE,cC/LK;EDgML,eAAA;EACA,gBAAA;AAhCR;;AAsCA;EACE;IACE,UAAA;EAnCF;EAqCA;IACE,UAAA;EAnCF;AACF;AAsCA;EACE;IACE,UAAA;IACA,wCAAA;EApCF;EAsCA;IACE,UAAA;IACA,iCAAA;EApCF;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `OxTqNFdiWKiOOBKsfOj_`,
	"wrapper": `vg9_rMNJWyDMfDESuvVz`,
	"header": `E9YcAkI1PQTt0FLG8Vma`,
	"badge": `KvbT0f8Vrs2trRGTIjUu`,
	"betaPill": `VuFQSkoP7oHJiczQI5Fr`,
	"sceneGeo": `v2szRqRRGOhMOj5fUpXW`,
	"iconGeo": `fayNrshveISvCKPhBScN`,
	"copyIcon": `fRxC68rOPaoSh0rMSLD3`,
	"qrCodeContainer": `E1R0l93Ex93Ixu45CwSw`,
	"controlButtons": `jc9XwDbH1EOE2R0T5qbV`,
	"locked": `wUHtdZpsETwDxMyGxJ0_`,
	"successOverlay": `TG3g_gaT6VH9HsadvB2I`,
	"fadeIn": `RIOCHFM5Xoiyq5qWh1Rz`,
	"successContent": `zU3TDWGTVnkRO6CrFyfI`,
	"slideIn": `LEIWuXIGzhXK9gx2Kyqt`,
	"successHeader": `FwCCXSEjPtRwVpxlXbvv`,
	"successIcon": `F_BdnAH_x9jkPPUtUdap`,
	"valueDemo": `ERTbxHPoSDzeHTz0KZqw`,
	"dataItem": `bgWZfJMplWSzZapnDRIa`,
	"icon": `EiSdHb4gDYS7uUp3Y6_j`,
	"dataContent": `bCmATtxDaNHH8dOW0Fni`,
	"label": `spRrEeN0zQ2RAJNQHaqb`,
	"value": `T4zlx9kFXOFUUulLj6OU`,
	"tokenStatus": `B4_LY01cIqV9iOFR3DAg`,
	"tokenIcon": `Hf6i_geka9ls_cbXLlkO`,
	"tokenText": `h2g2tBzF3ZJsFIGIJ7jN`,
	"upgradeHint": `OcaLS9vZT5JJgg773DkQ`
};
export default ___CSS_LOADER_EXPORT___;
